<script>
  import { createEventDispatcher } from "svelte";
  import Form from "./Form.svelte";
  import { focusNext } from "./Form.svelte";
  import { login, create, verify, uniqueNickname, load } from "../user.js";
  import { showLogin } from "../event.js";
  import { navigate } from "../router";
  import { HStack } from "../component/layout";
  import { Padding } from "../component/modifier";
  import { Email, validateEmail, Password, Digit, Text, Checkbox } from "./widget";

  const dispatch = createEventDispatcher();
  const close = async () => {
    dispatch("close");
  };

  export let step = 1;
  export let user_email = null;

  let steps = [
    {
      id: 1,
      name: "Création Compte",
      done: false,
      back: false,
      cancel: true,
      submit: "continue",
      next: 2,
      prev: null,
    },
    {
      id: 2,
      name: "Validation Compte",
      done: false,
      back: true,
      cancel: false,
      submit: "validate",
      next: 3,
      prev: 1,
    },
    {
      id: 3,
      name: "Félicitations",
      done: false,
      back: false,
      cancel: false,
      submit: "final",
      next: null,
      prev: 2,
    },
  ];

  let form = undefined;

  let nickname = null;
  let email = user_email;
  let password = null;
  let accept;
  let c1 = null;
  let c2 = null;
  let c3 = null;
  let c4 = null;
  let c5 = null;
  let c6 = null;
  let code;
  let digit_c1;

  let current = "";
  let showInfo = false;
  let infoMessage = null;
  let showError = false;
  let errorMessage = null;

  async function resendCode() {
    reset();
    await verify("send");
    infoMessage = "code envoyé";
    showInfo = true;
    c1 = null;
    c2 = null;
    c3 = null;
    c4 = null;
    c5 = null;
    c6 = null;
  }

  const submit = async () => {
    console.log("submit", step);

    if (step == 1) {
      await create(email, password, nickname);
      await login(email, password);
      await verify("send");
    } else if (step == 2) {
      code = "" + c1 + c2 + c3 + c4 + c5 + c6;
      await verify("verify", code);
    } else if (step == 3) {
      await load();
      navigate("#/select");
    }
  };

  function validateNickname(textbox) {
    if (textbox.value === "" || textbox.value === null || textbox.value === undefined) {
      textbox.setCustomValidity("Un pseudo est requis.");
    } else {
      uniqueNickname(textbox.value)
        .then(() => textbox.setCustomValidity(""))
        .catch(() => textbox.setCustomValidity("Ce pseudo est déjà utilisé."));
    }
    return true;
  }

  function validate(event) {
    switch (event.target.name) {
      case "email":
        validateEmail(event.target);
        break;
      case "nickname":
        validateNickname(event.target);
        break;
      case "c1":
      case "c2":
      case "c3":
      case "c4":
      case "c5":
      case "c6":
        if (
          event.target.value === "" ||
          event.target.value === null ||
          event.target.value === undefined
        ) {
          event.target.setCustomValidity("Un chiffre est requis.");
        } else {
          event.target.setCustomValidity("");
          focusNext(form);
        }
        break;
      default:
        break;
    }
  }
</script>

<Form
  bind:form
  bind:step
  bind:steps
  {submit}
  {validate}
  continueButton={"Créer"}
  validateButton={"Vérifier"}
  on:close
  allowBackButton={false}
  padding={false}>
  <div>
    {#if step == 1}
      <!-- nickname -->
      <Text
        id={"nickname"}
        reset
        required
        bind:value={nickname}
        icon="fa fa-user"
        label="Pseudo/Prénom"
        placeholder="Pseudo/Prénom"
        bind:current />

      <!-- email -->
      <Email id={"email"} required bind:value={email} bind:current />

      <!-- password -->
      <Password id={"password"} bind:value={password} bind:current />

      <!-- accept condition -->
      <Checkbox id={"accept"} bind:value={accept} bind:current required>
        <label for="rgpd_acceptance" class="control-label required">
          J'accepte les
          <a
            href="https://mariage-parfait.com/conditions/"
            target="_blank"
            rel="noopener"
            class="link-secondary cursor-pointer">
            conditions d'utilisation
          </a>
          et de
          <a
            href="https://mariage-parfait.com/confidentialite/"
            target="_blank"
            rel="noopener"
            class="link-secondary cursor-pointer">
            confidentialité
          </a>
          .
        </label>
      </Checkbox>

      <!-- Footer -->
      <span class="note">
        * J'ai dèja un compte,
        <a href="#/" on:click={() => close().then(() => showLogin.set(true))}> se connecter </a>
      </span>
    {:else if step == 2}
      <p>
        Un code de vérification vous a été envoyé à l'email
        <b>{email}</b>
        .
        <br />
        Entrez le code pour continuer.
      </p>
      <Padding>
        <HStack justify="space-evenly" alignment="normal">
          <Digit id={"c1"} focused bind:value={c1} bind:current />
          <Digit id={"c2"} bind:value={c2} bind:current />
          <Digit id={"c3"} bind:value={c3} bind:current />
          <Digit id={"c4"} bind:value={c4} bind:current />
          <Digit id={"c5"} bind:value={c5} bind:current />
          <Digit id={"c6"} bind:value={c6} bind:current />
        </HStack>
      </Padding>

      <!-- Footer -->
      <span class="note">
        J'ai perdu mon code,
        <a href="#/" on:click={resendCode}>m'en renvoyer un nouveau</a>
      </span>
    {:else if step == 3}
      <h1>Félicitations !</h1>
      <p>Vous pouvez maintenant accéder à votre mariage parfait</p>
    {/if}
  </div>
</Form>

<style>
  div {
    height: 250px;
    width: 480px;
  }

  @media screen and (max-width: 600px) {
    div {
      width: 100%;
    }
  }

  h1 {
    font-family: "Cinzel";
    font-size: 1.5rem;
  }

  .note {
    font-size: small;
  }

  p {
    text-align: center;
    font-size: small;
  }
</style>
